import arrowCircle from './arrow-circle.svg?raw';
import arrow from './arrow.svg?raw';
import check from './check.svg?raw';
import copy from './copy.svg?raw';
import squareDash from './square-dash.svg?raw';
import upDown from './up-down.svg?raw';

import buildingHistoric from './building_historic.svg?raw';
import buildingHospital from './building_hospital.svg?raw';
import buildingHotel from './building_hotel.svg?raw';
import buildingMultifamily from './building_multifamily.svg?raw';
import buildingOffice from './building_office.svg?raw';
import buildingSchool from './building_school.svg?raw';

import file from './file.svg?raw';

export default {
	check,
	arrow,
	arrowCircle,
	copy,
	squareDash,
	upDown,
	buildingHistoric,
	buildingHospital,
	buildingHotel,
	buildingMultifamily,
	buildingOffice,
	buildingSchool,
	file,
};
